import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api';

const DEFAULTS = {
  geocoding_provider: 'mapbox',
  // Beta-mode flags — default to "beta" (off) so a slow/failed config fetch
  // never accidentally exposes payment UI before the legal entity is ready.
  payments_enabled: false,
  rewards_visible: false,
};

const PublicConfigContext = createContext(DEFAULTS);

export function PublicConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULTS);

  useEffect(() => {
    let cancelled = false;
    api.get('/public/config')
      .then((res) => {
        if (!cancelled && res.data && typeof res.data === 'object') {
          setConfig({ ...DEFAULTS, ...res.data });
        }
      })
      .catch(() => {
        // Fail silently — keep defaults
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <PublicConfigContext.Provider value={config}>
      {children}
    </PublicConfigContext.Provider>
  );
}

export function usePublicConfig() {
  return useContext(PublicConfigContext);
}

export function useGeocodingProvider() {
  return useContext(PublicConfigContext).geocoding_provider;
}

export function usePaymentsEnabled() {
  return useContext(PublicConfigContext).payments_enabled;
}

export function useRewardsVisible() {
  return useContext(PublicConfigContext).rewards_visible;
}
